import { ReactComponent as HomeIcon } from "./assets/icons/home.svg";
import { ReactComponent as DiscountIcon } from "./assets/icons/discount.svg";
// import { ReactComponent as CampaignIcon } from "./assets/icons/campaign.svg";
import { ReactComponent as LogoutIcon } from "./assets/icons/logout.svg";
import { ReactComponent as CallDisabledIcon } from "./assets/icons/phone-disabled.svg";

// ADMIN ICONS
import { ReactComponent as Dashboard } from "./assets/icons/Dashboard.svg";
import { ReactComponent as CreateCampaignIcon } from "./assets/icons/Create_Campaign.svg";
import { ReactComponent as CampaignReportIcon } from "./assets/icons/Campaign_Report.svg";
import { ReactComponent as AgentReportIcon } from "./assets/icons/Agent_Report.svg";
import { ReactComponent as CreateAgentIcon } from "./assets/icons/Agent.svg";
import { ReactComponent as CreateUser } from "./assets/icons/add_user.svg";
import { ReactComponent as CampaignIcon } from "./assets/icons/Campaign.svg";
import { ReactComponent as Call } from "./assets/icons/phone-incoming.svg";
import { ReactComponent as Invalid } from "./assets/icons/bug.svg";
import { ReactComponent as Agent } from "./assets/icons/Agent.svg";
import { ReactComponent as Customer } from "./assets/icons/customers.svg";
import { ReactComponent as Webrtc } from "./assets/icons/webrtc.svg";


import {
  //AGENT COMPONENT
  AgentDashboard2,
  AgentCampaign,
  AgentCustomerList,
  AgentCampReport,
  ManuvalListCamp,
  //ADMIN COMPONENTS
  AdminCampaignList,
  AdminDashbaord,
  AdminAgents,
  CreateAgent,
  CreateCampaign,
  CampaignReport,
  DNCStatusReport,
  CallBackReport,
  AgentReport,
  OutgoingCallReport,
  LiveCallReport,
  //COMMONURLS
  Notfound,
  Login,
  Unauthorized,
  Activity,
  NewCampaign,
  CampaignCustomers
} from "./pages/index";
import { menu } from "@material-tailwind/react";
import AddUser from "./pages/Admin/AddUser";
import CampaignInvalidDataReport from "./pages/Admin/CampaignInvalidDataReport";
import WEBRTC from "./pages/Agent/Webrtc";
import AgentActivityReport from "./pages/Reports/AgentActivityReport";
import VsipOutgoingCampaignReport from "./pages/Reports/VsipOutgoingCampaignReport";
// import FollowupReport from "./pages/Reports/FollowupReport";
import FollowUpReport from "./pages/Agent/FollowUpReport";
// import FollowupReport from "./pages/Agent/Dashboard2/FollowupReport";


export const Icon = (props) => {
  return (
    <>
      <svg className="w-[35px] h-[35px]" viewBox="0 0 30 30">
        <defs>
          <linearGradient
            x1="30%"
            y1="92.034%"
            x2="50%"
            y2="7.2%"
            x3="45%"
            y3="50%"
            id="a"
          >InboundReport
            <stop offset="40%" stopColor="#AFD462" />
            <stop offset="60%" stopColor="#6BC698" />
            <stop offset="80%" stopColor="#0FB1E2" />
          </linearGradient>
        </defs>
        <props.icon
          className={` group-hover:fill-[url(#a)] ${props.active ? "fill-[url(#a)]" : "fill-[#A2A4A6]"
            } `}
        ></props.icon>
      </svg>
    </>
  );
};

export const SmallIcon = (props) => {
  return (
    <>
      <svg className="w-[25px] h-[25px] absolute translate-x-[0.5rem] right-0 bottom-0 bg-gray-800 rounded-xl p-0.5 z-0" viewBox="0 -2 23 32">
        <defs>
          <linearGradient
            x1="30%"
            y1="92.034%"
            x2="50%"
            y2="7.2%"
            x3="45%"
            y3="50%"
            id="a"
          >
            <stop offset="40%" stopColor="#AFD462" />
            <stop offset="60%" stopColor="#6BC698" />
            <stop offset="80%" stopColor="#0FB1E2" />
          </linearGradient>
        </defs>
        <props.icon
          className={` group-hover:fill-[url(#a)] ${props.active ? "fill-[url(#a)]" : "fill-[#A2A4A6]"
            } `}
          stroke="currentColor"
          strokeWidth="0"
        ></props.icon>
      </svg>
    </>
  );
};

const Adminroutes = [

  {
    type: "collapse",
    name: "Dashboard",
    key: "admin_dashboard",
    secton: "non_report",
    icon: Dashboard,
    subIcon: "",
    path: "dashboard",
    component: <AdminDashbaord />,
  },

  {
    type: "collapse",
    name: "Campaigns",
    key: "campaign_list",
    secton: "non_report",
    icon: CampaignIcon,
    subIcon: "",
    path: "campaign/list",
    component: <AdminCampaignList />,
  },
  {
    type: "collapse",
    name: "Agents",
    key: "agent_list",
    secton: "non_report",
    icon: CreateAgentIcon,
    subIcon: "",
    path: "list/agent",
    component: <AdminAgents />,
  },
  {
    type: "collapse",
    name: "Campaign Report",
    key: "campgin_report",
    secton: "report",
    icon: CampaignIcon,
    subIcon: CampaignReportIcon,
    path: "report/campaign",
    component: <CampaignReport />,
  },
  {
    type: "collapse",
    name: "Vsip Report",
    key: "Vsip_Report",
    secton: "report",
    subIcon: CampaignReportIcon,
    icon: CampaignIcon,
    path: "report/vsip-report",
    component: <VsipOutgoingCampaignReport />,
  },

  {
    type: "collapse",
    name: "Callback Report",
    key: "callback_report",
    secton: "report",
    icon: Call,
    subIcon: CampaignReportIcon,
    path: "report/callback",
    component: <CallBackReport />,
  },

  {
    type: "collapse",
    name: "Agent Report",
    key: "agent_report",
    secton: "report",
    icon: Agent,
    subIcon: CampaignReportIcon,
    path: "report/agent",
    component: <AgentReport />,
  },

  {
    type: "collapse",
    name: "Agent Activity Report",
    key: "agent_activity_report",
    secton: "report",
    icon: Agent,
    subIcon: CampaignReportIcon,
    path: "report/activity_report",
    component: <AgentActivityReport />,
  },

  {
    type: "collapse",
    name: "Live Call Report",
    key: "live_call_report",
    secton: "report",
    icon: Call,
    subIcon: CampaignReportIcon,
    path: "report/live_call",
    component: <LiveCallReport />,
  },
  
  {
    type: "collapse",
    name: "Followup Report",
    key: "followup_report",
    secton: "report",
    icon: Agent,
    subIcon: CampaignReportIcon,
    path: "report/followup",
    component: <FollowUpReport />,
  },

  {
    type: "collapse",
    name: "Campaign Customers",
    key: "campaign_customers",
    secton: "report",
    icon: Customer,
    subIcon: CampaignReportIcon,
    path: "campaign/customers",
    component: <CampaignCustomers />,
  },

  {
    type: "collapse",
    name: "Invalid Data Reports",
    key: "campaign_invalid_data_report",
    secton: "report",
    icon: Invalid,
    subIcon: CampaignReportIcon,
    path: "campign/invalid",
    component: <CampaignInvalidDataReport />,
  },
  {
    type: "collapse",
    name: "DNC Status Report",
    key: "dnc_status_report",
    secton: "report",
    icon: CallDisabledIcon,
    subIcon: CampaignReportIcon,
    path: "report/dnc-status-report",
    component: <DNCStatusReport />,
  },
];


export default Adminroutes;

export const AgentRoutes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "agent_dashboard",
    secton: "non_report",
    icon: Dashboard,
    path: "dashboard",
    component: <AgentDashboard2 />,
  },
  {
    type: "collapse",
    name: "Campaigns",
    key: "campaign_report",
    secton: "non_report",
    icon: CampaignIcon,
    path: "campaigns/:type/",
    component: <AgentCampReport />,

  },
  {
    type: "collapse",
    name: "Customer List",
    key: "agent_customer_list",
    secton: "non_report",
    icon: Customer,
    path: "customers",
    component: <AgentCustomerList user_type="agent" edit_fb={true} />,
  },
  {
    type: "collapse",
    name: "Campaign Report",
    key: "agent_campaign_report",
    secton: "report",
    icon: CampaignIcon,
    subIcon: CampaignReportIcon,
    path: "report/campaign",
    component: <CampaignReport />,
  },
  {
    type: "collapse",
    name: "Callback Report",
    key: "agent_callback_report",
    secton: "report",
    icon: Call,
    subIcon: CampaignReportIcon,
    path: "report/callback",
    component: <CallBackReport />,
  },
  {
    type: "collapse",
    name: "Agent Activity Report",
    key: "agent_activity_report",
    secton: "report",
    icon: Agent,
    subIcon: CampaignReportIcon,
    path: "report/activity_report",
    component: <AgentActivityReport />,
  },
  {
    type: "collapse",
    name: "Followup Report",
    key: "agent_followup_report",
    secton: "report",
    icon: Agent,
    subIcon: CampaignReportIcon,
    path: "report/followup",
    component: <FollowUpReport />,
  },
  {
    name: "Vsip Report",
    key: "Vsip_report",
    secton: "report",
    icon: Customer,
    subIcon: CampaignReportIcon,
    path: "agent/vsip",
    component: <VsipOutgoingCampaignReport />,
  },
  // {
  //   type: "collapse",
  //   name: "WebRTC",
  //   key: "web_rtc",
  //   secton: "non_report",
  //   icon: Webrtc,
  //   subIcon: "",
  //   path: "list/agent",
  //   component: <WEBRTC />,
  // },

  // {
  //   type: "collapse",
  //   name: "Outgoing report",
  //   key: "outgoing-call-report",
  // secton: "non_report",
  //   icon: CampaignReportIcon,
  //   path: "agent/outgoing-call-report",
  //   component: <OutgoingCallReport />,
  // },
];


export const CommonRoutes = [
  { name: "Login", icon: "StoreIcon", path: "login", component: <Login /> },
  {
    name: "Unathorized",
    icon: "StoreIcon",
    path: "unauthorized",
    component: <Unauthorized />,
  },
  { name: "404", icon: "StoreIcon", path: "*", component: <Notfound /> },
];
